import { openBlock as e, createElementBlock as t, renderSlot as r } from "vue";
/* empty css                    */
import s from "./design-system.es128.js";
const c = {
  name: "DsCardFooter",
  compatConfig: { MODE: 3 }
}, n = { class: "ds-card-footer" };
function a(o, d, p, f, _, i) {
  return e(), t("section", n, [
    r(o.$slots, "default", {}, void 0, !0)
  ]);
}
const $ = /* @__PURE__ */ s(c, [["render", a], ["__scopeId", "data-v-b823e17c"]]);
export {
  $ as default
};
//# sourceMappingURL=design-system.es42.js.map
